import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import Table from '../../components/Table';
import Guide from '../../components/Guide';
import managerActions from '../../actions/managers';
import managerTable from '../../tables/managers';
import formHelpers from '../../helpers/FormHelpers';
import modalActions from '../../actions/modal';
import modalInfo from '../../helpers/managers/ManagersInfo';
import managerFields from '../../forms/manager/create';
import updateManagerFields from '../../forms/manager/update';
import populateForm from '../../helpers/PopulateForm';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { validatePhases, checkForErrors } from '../../helpers/Validation';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';

class Managers extends Component {
  constructor() {
    super();
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
    this.handleNewClick = this.handleNewClick.bind(this);
    this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
    this.performCreateOrUpdate = this.performCreateOrUpdate.bind(this);
    this.handleActiveClick = this.handleActiveClick.bind(this);
    this.resetManager = this.resetManager.bind(this);
  }

  componentWillMount() {
    const { dispatch, vendor } = this.props;
    dispatch(managerActions.list());
    this.resetManager();
  }

  handleSelectFieldChange(option, name) {
    formHelpers.handleSelectFieldChange(option, name, 'fields', this);
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, 'fields', this);
  }

  handleSelectClick(name) {
    formHelpers.handleSelectClick(name, 'fields', this);
  }

  resetManager() {
    this.setState({
      updateField: false,
      fields: managerFields,
    });
  }

  performCreateOrUpdate() {
    const { fields, updateField } = this.state;
    const { dispatch, vendor, managers } = this.props;
    let data = extractPhasesOrFail({ fields });
    if (data && updateField) {
      data.vendor = vendor.selected.apikey;
      dispatch(managerActions.update(data, updateField.apikey));
      this.resetManager();
      this.handleModalToggle();
    } else if (data) {
      data.vendor = vendor.selected.apikey;
      dispatch(managerActions.create(data));
      this.resetManager();
      this.handleModalToggle();
    } else {
      this.setState({
        fields: formHelpers.blurphase(fields),
      });
    }
  }

  handleEditClick(manager) {
    this.props.dispatch(modalActions.modalToggle(true));
    this.setState({
      updateField: manager,
      fields: populateForm(manager, updateManagerFields),
    });
  }

  handleNewClick() {
    this.setState({
      fields: JSON.parse(JSON.stringify(managerFields)),
    });
    this.handleModalToggle();
  }

  handleModalToggle() {
    const { dispatch, modal } = this.props;
    dispatch(modalActions.modalToggle(!modal.showModal));
  }

  handleActiveClick(loc) {
    // TODO: Add support for toggling user active
  }

  render() {
    return (
      <div>
        <Header
          handlePrimaryClick={this.handleNewClick}
          handleLogout={this.props.handleLogoutClick}
          primaryText="NEW USER"
          title="USERS"
        />
        <Table
          handleEditClick={this.handleEditClick}
          rows={this.props.managers.data}
          handleActiveClick={this.handleActiveClick}
          columns={managerTable}
        />
        {this.props.modal.showModal && (
          <Modal handleCloseClick={this.handleModalToggle} title="Portal User">
            <div className="signup__guide">
              <Guide header={modalInfo[0].subTitle} message={modalInfo[0].content} />
            </div>
            <div className="signup__form">
              <div>{formHelpers.buildFields(this.state.fields, this)}</div>
              <Button allowHover={true} text="Finish" onClick={this.performCreateOrUpdate} />
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(state => ({
    modal: state.modal,
    vendor: state.vendor,
    managers: state.managers,
  }))(Managers)
);



/** WEBPACK FOOTER **
 ** ./src/containers/Users/index.js
 **/